import useNonF2fMedicalCategories from './useNonF2fMedicalCategories';

export { useNonF2fMedicalCategories };
